import React from "react";

const RevenueAreaTrend = () => {
  return (
    <div className="mt-4 h-[160px] max-w-[263px]">
      <svg viewBox="0 0 260 150" className="h-full w-full" preserveAspectRatio="none">
        <defs>
          <linearGradient id="revenue-fill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#8B5CF6" stopOpacity="0.28" />
            <stop offset="100%" stopColor="#8B5CF6" stopOpacity="0.08" />
          </linearGradient>
        </defs>

        <path
          d="M 0 90 C 28 74, 52 62, 84 68 C 108 72, 126 94, 151 86 C 176 78, 199 52, 260 40 L 260 150 L 0 150 Z"
          fill="url(#revenue-fill)"
        />
        <path
          d="M 0 90 C 28 74, 52 62, 84 68 C 108 72, 126 94, 151 86 C 176 78, 199 52, 260 40"
          fill="none"
          stroke="#8B5CF6"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default RevenueAreaTrend;
